import React, { useEffect } from "react";
import { Button } from "components/UI/Button/Button";
import { Trans } from "@lingui/macro";
import { InputText } from "components/UI/InputText/InputText";
import { useInputChange } from "hooks/useInputChange";
import { useDispatch, useSelector } from "react-redux";
import { typeStatisticsState } from "model/dashboardStatistics/dStatisticsReducer";
import { dStatisticsSetPeriodAC } from "model/dashboardStatistics/dStatisticsActionCreators";
import { dateFilterValues } from "../index";

// Types
export type typePopupPeriod = {
  setOpenPeriodPopup: React.Dispatch<React.SetStateAction<boolean>>;
};

// Component
export const PopupPeriod: React.FC<typePopupPeriod> = ({
  setOpenPeriodPopup,
}) => {
  const dispatch = useDispatch();

  const dateToDateField = (date: Date) => {
    const year = date.getFullYear();
    let month: string =
      date.getMonth() + 1 < 10
        ? "0" + String(date.getMonth() + 1)
        : String(date.getMonth() + 1);
    let day: string =
      date.getDate() < 10
        ? "0" + String(date.getDate())
        : String(date.getDate());
    return year + "-" + month + "-" + day;
  };

  const period = useSelector(
    (state: { dStatistics: typeStatisticsState }) => state.dStatistics.period,
  );

  const oldFromDate = new Date(period.dateFrom);
  const oldToDate = new Date(period.dateTo);

  const {
    value: fromValue,
    changeValueHandler: fromChangeValueHandler,
    setValue: setFromValue,
  } = useInputChange(dateToDateField(oldFromDate));
  const {
    value: toValue,
    changeValueHandler: toChangeValueHandler,
    setValue: setToValue,
  } = useInputChange(dateToDateField(oldToDate));

  useEffect(() => {
    let from = new Date(fromValue);
    let to = new Date(toValue);
    if (from > to) {
      setToValue(fromValue);
    }

    // eslint-disable-next-line
  }, [fromValue]);

  useEffect(() => {
    let from = new Date(fromValue);
    let to = new Date(toValue);
    if (to < from) {
      setFromValue(toValue);
    }
    // eslint-disable-next-line
  }, [toValue]);

  const onSetPeriod = () => {
    const fromDate = new Date(fromValue);
    const toDate = new Date(toValue);
    toDate.setHours(23, 59, 59, 999);

    dispatch(
      dStatisticsSetPeriodAC(
        {
          dateFrom: fromDate.toISOString(),
          dateTo: toDate.toISOString(),
        },
        dateFilterValues.PERIOD,
      ),
    );

    setOpenPeriodPopup(false);
  };

  return (
    <div className="flex flex-col gap-6">
      <div className="flex gap-4 flex-wrap">
        <div>
          <InputText
            id="from"
            type="date"
            label={<Trans>From</Trans>}
            value={fromValue}
            onChange={fromChangeValueHandler}
          />
        </div>
        <div>
          <InputText
            id="to"
            type="date"
            label={<Trans>To</Trans>}
            value={toValue}
            onChange={toChangeValueHandler}
          />
        </div>
      </div>
      <div className="flex gap-2 justify-end">
        <Button
          type="button"
          secondary={true}
          label={<Trans>Cancel</Trans>}
          onClick={() => setOpenPeriodPopup(false)}
        />
        <Button
          type="button"
          label={<Trans>Set period</Trans>}
          onClick={onSetPeriod}
        />
      </div>
    </div>
  );
};
